module.exports = __webpack_public_path__ + "img/standard_5000ml.2b4b3087.png";